export function stringifyCard(x, opts = {}) {
    const brand = x.card.brand[0].toUpperCase() + x.card.brand.slice(1);
    return (`${brand} ending in ${x.card.last4}` +
        (opts.includeExpiration ? ` (exp ${x.card.exp_month}/${x.card.exp_year})` : ""));
}
//# sourceMappingURL=credit-card.js.map